
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/buyUProductOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import {
  getOrderList,
  orderExport,
  setUnpaidOrder,
  setPaidOrder,
  depositOrderStatistical
} from '@/api/order/deposit'
import { Form as ElForm } from 'element-ui'
import { notifiedStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import orderDetail from './components/depositDetail.vue'
import { delObjEmptyKey } from '@/utils'
import { setOrderStatusRules } from '@/utils/rules'
import { checkNeedAudit, checkPermission } from '@/utils/permission'
import { operationMessage } from '@/utils/message'
import { getCurrentDate, dateToSeconds } from '@/utils/dateTime'
import PicsUploader from '@/components/PicsUploader/index.vue'
import depositBatchNotify from './components/depositBatchNotify.vue'
import { getAccountGroupList } from '@/api/product/accountGroup'
import kick from './components/kickOut.vue'
import { getType } from '@/utils/cookies'
import {
  antTopupList,
  getStatistics,
  changeOrderStatus
} from '@/api/order/topupOrder'

@Component({
  name: 'depositList',
  components: {
    orderDetail,
    PicsUploader,
    depositBatchNotify,
    kick
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  private data_source: string = 'simple_order'
  queryForm: any = {
    upstream_remarks: null,
    order_number: null,
    ant_username: null,
    status: null,
    product: null,
    min_amount: '',
    max_amount: '',
    min_request_amount: '',
    max_request_amount: '',
    start_time: null,
    end_time: null,
    notify_start_time: null,
    notify_end_time: null,
    product_name: null,
    product_account_name: null,
    success_start_time: null,
    success_end_time: null,
    // product_type: 'deposit',
    product_account_group: null,
    test_order: null,
    pay_time_duration: null,
    payment_type: 'IMPS'
  }

  private amountType: string = 'Paid Amount'
  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private instruction: any[] = []
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  // private total = {}
  private total = 0

  private dialogVisible: boolean = false
  private setForm: any = {}
  private payTime: any = ''
  private selectList: any[] = []
  private ordernumbers: any[] = []

  private rules = setOrderStatusRules
  private loading: boolean = false

  private currentOrdernumber: number | null = null
  private drawer: boolean = false
  private fixTime: any = null
  private sysType: any = ''

  // 跳转地址
  private jumpAddress(row, type) {
    if (type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row}/transfers`)
    } else if (type === 'erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    }
  }
  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      if (this.queryForm.currency) {
        delete this.queryForm.currency
      }
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      this.orderList = []
      await antTopupList(data).then((res: any) => {
        // this.orderList = res.results
        this.orderList = this.handleContentText(res.results)
        this.total = res.count
        this.listLoading = false
        this.currentPage = this.currentPage
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private handleContentText(list: any[]) {
    return list.map((item: any) => {
      const remarks: string = item.upstream_remarks

      if (remarks) {
        const strs = remarks.split('_').map((str: any) => {
          if (str.includes('Generate Address')) {
            let w = str.split('Generate Address', 2)[1]
            let a = w.split('(', 2)[1]
            let b = a.split(')', 2)[0]
            str =
              `<span>Generate Address(</span> 
              <span onclick="jumpAddress('${item.wallet_address}','${item.product_account_type}')" style="color:#1890ff;cursor:pointer;">` +
              b +
              `</span><span>)</span>`
          }
          return str
        })
        item.upstream_remarks = strs.join('_')
      }
      return item
    })
  }

  private isDisabled(row, index) {
    return row.status === 1 && row.notify_status !== 1
  }

  private handleSelectionChange(list) {
    this.selectList = list
  }

  private changeAmount() {
    this.queryForm.min_request_amount = null
    this.queryForm.max_request_amount = null
    this.queryForm.min_amount = null
    this.queryForm.max_amount = null
  }

  get authCode() {
    return this.setForm.oldStatus === 1
      ? 'change_paid_deposit_order_status'
      : 'change_unpaid_deposit_order_status'
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  private isCanSet(info: any) {
    return info.status === 1
      ? checkPermission('change_paid_deposit_order_status')
      : checkPermission('change_unpaid_deposit_order_status')
  }

  private openDialog(info: any) {
    this.setForm = {
      ...info,
      oldStatus: info.status,
      status: null,
      paid_time: null,
      upstream_ordernumber: null
    }
    this.fixTime = null
    this.dialogVisible = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  private getTimeStamp(val) {
    this.fixTime = val
    this.setForm.paid_time = dateToSeconds(this.fixTime)
  }

  private immediUpdate(e) {
    this.$nextTick(() => {
      if (e == null) {
        this.setForm.paid_time = ''
      }
    })
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async setOrderStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        let { ordernumber, status, remarks, attach, upstream_ordernumber } =
          this.setForm
        // if (this.setForm.paid_time === '') {
        //   paid_time = ''
        // }
        const data: any = {}
        data.name = this.setForm.ordernumber
        data.body = {
          status,
          remarks,
          attach,
          upstream_ordernumber
        }
        delObjEmptyKey(data)
        try {
          // if (this.setForm.oldStatus === 0) {
          //   // 未支付 => 支付
          //   await setUnpaidOrder(data).then(() => {
          //     operationMessage(
          //       checkNeedAudit('change_unpaid_deposit_order_status') !==
          //         undefined
          //     )
          //     this.flagStr()
          //     this.loading = false
          //   })
          // } else {
          //   await setPaidOrder(data).then(() => {
          //     operationMessage(
          //       checkNeedAudit('change_paid_deposit_order_status') !== undefined
          //     )
          //     this.flagStr()
          //     this.loading = false
          //   })
          await changeOrderStatus(data).then(() => {
            this.flagStr()
            this.loading = false
          })
          this.closeDialog()
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private openDrawer(row: any) {
    this.currentOrdernumber = row.ordernumber
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      upstream_remarks: null,
      order_number: null,
      ant_username: null,
      start_time: null,
      end_time: null,
      status: null,
      product: null,
      notify_start_time: null,
      notify_end_time: null,
      product_code: null,
      product_account_no: null,
      min_amount: '',
      max_amount: '',
      min_request_amount: '',
      max_request_amount: '',
      success_start_time: null,
      success_end_time: null,
      product_account_group: null,
      test_order: null,
      pay_time_duration: null,
      payment_type: 'IMPS'
    }
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.notifyDate = getCurrentDate()
    this.successDate = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.depositOrderStatistical()
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  // 入金订单统计
  private async depositOrderStatistical() {
    try {
      if (this.queryForm.currency) {
        delete this.queryForm.currency
      }
      let data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getStatistics(data).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }
  private queryName: any = ''
  private productNameChange() {
    this.queryForm.product_account_group = ''
    // this.getProductAccountGroup(this.queryName)
  }

  // 远程查询 inProductList
  private accountGroupList: any[] = []
  private async getProductAccountGroup(query: string) {
    this.queryName = query
    try {
      const data = {
        product_code: this.queryForm.product_code,
        name: query,
        page_size: 50
      }
      await getAccountGroupList(data).then((res: any) => {
        this.accountGroupList = res.results
      })
    } catch (e) {}
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.IN_ORDER_STATUS_CHOICES
    })
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    ;(window as any).jumpAddress = this.jumpAddress
    this.init()
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.buyUOrder`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
